import { render, staticRenderFns } from "./Trail.vue?vue&type=template&id=1820e5d5&scoped=true&"
import script from "./Trail.vue?vue&type=script&lang=js&"
export * from "./Trail.vue?vue&type=script&lang=js&"
import style0 from "./Trail.vue?vue&type=style&index=0&id=1820e5d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1820e5d5",
  null
  
)

export default component.exports